export enum POPUP_ALERT_TYPE {
    DANGER,
    WARNING,
    SUCCESS,
    INFO
}